var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      value: !_vm.product.removeIntrastatData,
                      label: _vm.$ct("has-data"),
                    },
                    on: {
                      input: function ($event) {
                        _vm.product.removeIntrastatData = !$event
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: {
                      disabled: _vm.product.removeIntrastatData,
                      fancy: "",
                      label: _vm.$ct("excnt"),
                    },
                    model: {
                      value: _vm.data.Excnt,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "Excnt", $$v)
                      },
                      expression: "data.Excnt",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: {
                      disabled: _vm.product.removeIntrastatData,
                      fancy: "",
                      label: _vm.$ct("extreg"),
                    },
                    model: {
                      value: _vm.data.Extreg,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "Extreg", $$v)
                      },
                      expression: "data.Extreg",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: {
                      disabled: _vm.product.removeIntrastatData,
                      fancy: "",
                      label: _vm.$ct("extgo"),
                    },
                    model: {
                      value: _vm.data.Extgo,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "Extgo", $$v)
                      },
                      expression: "data.Extgo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      disabled: _vm.product.removeIntrastatData,
                      fancy: "",
                      decimals: 2,
                      min: 0,
                      label: _vm.$ct("exweight"),
                    },
                    model: {
                      value: _vm.data.Exweight,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "Exweight", $$v)
                      },
                      expression: "data.Exweight",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: {
                      disabled: _vm.product.removeIntrastatData,
                      fancy: "",
                      label: _vm.$ct("excntori"),
                    },
                    model: {
                      value: _vm.data.Excntori,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "Excntori", $$v)
                      },
                      expression: "data.Excntori",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }